/** @format */

import vLogo from "../assets/vlogo.png";
import "../App.css";
const Vlogo = () => {
	return (
		<div className="logo">
			<img src={vLogo} alt="" />
		</div>
	);
};

export default Vlogo;
